module.exports = __webpack_public_path__ + "img/quest_icon_0025_fire.b4d92ce6.png";